import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  @media(max-width: 991px) {
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }
`;

export const GroupField = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  & button {
    max-width: 250px;
  }
  @media(max-width: 991px) {
    align-items: flex-end;
  }
`;

export const Label = styled.label`
  display: inline-block;
  font-family: 'AvenirNext';
  font-size: 18px;
  color: #3b3b3b;
  margin: 0 10px;
  white-space: nowrap;
  @media(max-width: 991px) {
    min-width: 110px;
    text-align: right;
  }
`;

export const Flex = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  @media(max-width: 991px) {
    flex-direction: column;
    align-items: flex-end;
  }
`;

export default {
  label: {
    display: 'inline-block',
    fontFamily: 'AvenirNext-Medium',
    fontSize: '18px',
    fontWeight: '500',
    color: '#3b3b3b',
    margin: '0 10px'
  },
  control: {
    margin: '0 3px 5px'
  }
}

export const newStyles = theme => ({
  select: {
    backgroundColor: 'transparent',
    padding: theme.spacing(0, 1),
    '& > .MuiSelect-icon': {
      color: theme.palette.primary.main,
    },
    '&:before': {
      borderBottomColor: theme.palette.primary.main,
    }
  },
  selectInput: {
    padding: 3,
    minHeight: 0,
    fontFamily: 'AvenirNext-Bold',
    fontSize: '18px',
    color: theme.palette.primary.main,
  }
})